var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('span',{staticClass:"centered",staticStyle:{"padding":"0px"}},[_vm._v("brutalism")]),_c('span',{staticClass:"centered anno",staticStyle:{"padding":"0px"}},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }